import { useAllowCorporateDashboard } from "hooks/useAllowCorporateDashboard";
import DowntimeDashboardLink from "./components/DowntimeDashboardLink.view";
import LocationsMenu from "./components/LocationsMenu.view";
import { Divider, ListItem } from "@mui/material";
import useRolesPermissions from "hooks/useRolesPermissions";
import DowntimeSettingsLink from "./components/DowntimeSettingsLink.view";

const DowntimeAppDrawerItems = () => {
    const { CORPORATE_PERMISSIONS } = useRolesPermissions();
    const { isAllowedToUseCorporateDashboard } = useAllowCorporateDashboard();
    return (
        <>
            {isAllowedToUseCorporateDashboard && <DowntimeDashboardLink />}
            <LocationsMenu />
            <Divider />
            <ListItem disablePadding>
                {CORPORATE_PERMISSIONS?.sidebarPermissions?.showSettingsLink && <DowntimeSettingsLink />}
            </ListItem>
        </>
    );
};

export default DowntimeAppDrawerItems;
